import React from 'react';
import { IconProps } from '.';

const SvgCoupon = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.5 4.5v4.041c.778.128 1.451.539 1.936 1.023C5.02 10.15 5.5 11.012 5.5 12s-.479 1.85-1.064 2.436c-.485.484-1.158.895-1.936 1.023V19.5h19v-4.041c-.777-.128-1.451-.539-1.936-1.023C18.98 13.85 18.5 12.988 18.5 12s.479-1.85 1.064-2.436c.485-.484 1.159-.895 1.936-1.023V4.5h-19ZM1 3h22v7h-1c-1 0-2 1-2 2s1 2 2 2h1v7H1v-7h1c1 0 2-1 2-2s-1-2-2-2H1V3Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='m8.47 14.47 6-6 1.06 1.06-6 6-1.06-1.06Z' clipRule='evenodd' />
      <path
        fill={color}
        d='M11 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z'
      />
    </svg>
  );
};

export default SvgCoupon;
